import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dropdown position-static" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-sm btn-primary dropdown-toggle",
  type: "button",
  id: "dropdownAcoesButton",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " Ações ", -1)
const _hoisted_3 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownAcoesButton"
}
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.acoes, (acao, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: acao.label + index
        }, [
          (acao.onTap)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "dropdown-item",
                type: "button",
                onClick: ($event: any) => (acao.onTap(_ctx.id)),
                style: {"font-weight":"normal"}
              }, _toDisplayString(acao.label), 9, _hoisted_4))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                class: "dropdown-item",
                to: {
            name: acao.nomeRota,
            params: { id: _ctx.id },
          }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(acao.label), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
        ]))
      }), 128))
    ])
  ]))
}